import React from 'react';
import styled from 'styled-components';
import { components } from 'react-select';

const Triangle = styled.span`
  transform: scaleX(1.5);
  &:before {
    content: "\u25bc";
    font: normal 12px/100% Texta, Arial, Helvetica, sans-serif;
  }
`;

const DropdownIndicator = props => (
  <components.DropdownIndicator {...props}>
    <Triangle />
  </components.DropdownIndicator>
);

export default DropdownIndicator;
